export const APP_CONFIG = {
  name: 'AryanFix Agent Portal',
  tagline: 'Private operations workspace for AryanFix agent staff.',
  emoji: '✦',
  icon: 'LayoutDashboard',
  defaultTheme: 'system',
  defaultLoginRoute: '/agent/login',
};

export const AUTH_PROFILES = [
  {
    key: 'admin',
    name: 'Admin_c',
    profileSlug: "|rcqd5sSSWU28IKD7PLI7YekcOJQsRMO1rH1i3/rD8Jg=",
    redirectAfterAuth: '/admin-reconciliation',
    authPage: {
      loginTitle: 'Platform Admin Sign In',
      signupTitle: 'Create Platform Admin Account',
      loginDescription: null,
      signupDescription: null,
    },
    altLinksLeadIn: 'Go to the right portal',
    altLinks: [
      { href: '/agent/login', label: 'I am Agent' }
    ],
    reportsTo: null,
    hasSignup: false,
  },
  {
    key: 'agent',
    name: 'Agent_c',
    profileSlug: "|rcqd5sSSWU28IKD7PLI7YTBjpt96m6eIeShIzuFw1RY=",
    redirectAfterAuth: '/',
    authPage: {
      loginTitle: 'Agent Sign In',
      signupTitle: 'Create Agent Account',
      loginDescription: null,
      signupDescription: null,
    },
    altLinksLeadIn: 'Go to the right portal',
    altLinks: [
      { href: '/admin/login', label: 'I am Platform Admin' }
    ],
    reportsTo: "Admin_c",
    hasSignup: false,
  }
];

export const GENERIC_AUTH = {
  loginTitle: 'Agent sign in',
  signupTitle: 'Account creation is restricted',
  loginDescription: 'Private workspace for authorized AryanFix agent staff.',
  signupDescription: 'Public registration is disabled. Ask the business owner for an invitation.',
  redirectAfterAuth: '/',
};
